export default "__VITE_ASSET__D62$6i_J__"